module.exports = __webpack_public_path__ + "img/hd.3b25287e.png";